// src/store/slices/product-slice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: []
};

const productSlice = createSlice({
  name: 'product', // action type prefix; doesn't have to match store key
  initialState,
  reducers: {
    setProducts(state, action) {
      state.products = Array.isArray(action.payload) ? action.payload : [];
    },
    clearProducts(state) {
      state.products = [];
    }
  }
});

export const { setProducts, clearProducts } = productSlice.actions;
export default productSlice.reducer;

// (optional) selector — adjust the root key to match your combineReducers
// If rootReducer = { product: productReducer }:
export const selectProducts = (state) => state.product.products;
// If rootReducer = { products: productReducer }:
// export const selectProducts = (state) => state.products.products;
